import { render, staticRenderFns } from "./agreements-table.component.vue?vue&type=template&id=f036d01e&scoped=true&"
import script from "./agreements-table.component.vue?vue&type=script&lang=ts&"
export * from "./agreements-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./agreements-table.component.vue?vue&type=style&index=0&id=f036d01e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f036d01e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
